@if (loaded) {
  <div class="mainContainer container">
    <div class="titleContainer">
      <div class="title" [ngStyle]="getTextColor()">
        {{ module?.title ?? '' }}
        <span>{{ 'moduleCompletion.hashtagGameResults' | translate }}</span>
      </div>
    </div>
    @if (medalOptions && loaded) {
      <div class="lottieContainer">
        <ng-lottie [styles]="styles" [options]="medalOptions" (animationCreated)="animCreated($event)"></ng-lottie>
      </div>
    }
    <div class="contentContainer">
      <div class="infoContainer">
        <div class="title">
          {{ 'moduleCompletion.perfectScore' | translate: { questionCount: questionCount } }}
        </div>
        <div class="text">
          {{ 'moduleCompletion.nextLeague' | translate }}
        </div>
        <div class="buttons">
          <div (click)="navigate()" class="button secondary">
            {{ 'moduleCompletion.menuButton' | translate }}
          </div>
          @if (hasNextLeague()) {
            <div (click)="goToNextLeague()" class="button primary">
              <span>{{ 'moduleCompletion.nextLeagueButton' | translate }}</span>
              <span aria-hidden="true">→</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
